module.exports = __webpack_public_path__ + "img/icon-check-blue.08c1909b.svg";